import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    animationGrid: {
      padding: theme.spacing(6),
    },
    animationTextGrid: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
    },
    animationTitle: {
      fontFamily: 'Montserrat',
      fontSize: '1.2rem',
      fontWeight: 'bold',
      margin: '0 30px',
      textAlign: 'center',
    },
    button: {
      height: 40,
      width: '30%',
      zIndex: 12,
    },
    header: {
      height: '80px',
    },
    metricsGrid: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      padding: theme.spacing(2),
      width: '100%',
    },
    metricsPaper: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: theme.spacing(4),
      width: '100%',
    },
    optionCircle: {
      alignItems: 'center',
      cursor: 'pointer',
      borderRadius: 50,
      display: 'flex',
      height: '5vw',
      justifyContent: 'center',
      minHeight: 50,
      minWidth: 50,
      width: '5vw',
    },
    optionsGrid: {
      alignContent: 'center',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: theme.spacing(4),
      width: '100%',
    },
    questionGrid: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: theme.spacing(6),
    },
    questionsGrid: {
      alignContent: 'center',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
    },
    questionPaper: {
      alignItems: 'center',
      height: '40vh',
      justifyContent: 'center',
      width: '100%',
    },
    questionTitle: {
      fontFamily: 'Montserrat',
      fontSize: '1.6rem',
      fontWeight: 'bold',
      margin: '10px 2vw',
      textAlign: 'center',
      width: '100%',
    },
    subtitle: {
      fontFamily: 'Montserrat',
      fontSize: '1.4rem',
      fontWeight: 'bold',
      margin: '0',
      textAlign: 'left',
    },
    stepText: {
      alignItems: 'center',
      cursor: 'pointer',
      display: 'flex',
      fontFamily: 'Montserrat',
      fontSize: '1.1rem',
      fontWeight: 'bold',
      textAlign: 'center',
    },
  })
);
